import React from 'react';
import { IconButton } from '../IconButton';
import { RenderNavigator } from './types';

export const defaultRenderNavigator: RenderNavigator = (props) => (
    <IconButton {...props} size="medium" appearance="transparent" />
);
